import styled from "styled-components";
import PaginatedTable from "../../Componentes/Utils/PaginatedTable";
import { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { useModal } from "../../contexts/ModalContext";
import { RiRefreshLine } from "react-icons/ri";
import { formatCurrency } from "../../Funcoes/formatCurrency";
import ModalSelecionarPc from "./ModalSelecionarPc";

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    border-bottom: 1.2px solid #d3d3d3;
    box-sizing: border-box;
`;

const Title = styled.p`
    color: #333;
    font-size: 16px;
    font-weight: bold;
    margin: auto 0 auto 15px;
`;

const Subtitle = styled.span`
    color: #666;
    font-size: 13px;
    font-weight: normal;
    margin-left: 10px;
`;

const ActionsWrapper = styled.div`
    height: 30px;
    margin-left: auto;
    margin-right: 15px;
    display: flex;
    gap: 10px;
    align-items: center;

    & button {
        height: 100%;
        padding: 0 15px;
        border: 1.2px solid #d3d3d3;
        border-radius: 4px;
        background-color: transparent;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    & button:hover {
        background-color: #f0f0f0;
    }
`;

const RefreshIcon = styled(RiRefreshLine)`
    width: 15px;
    height: 15px;
    color: #333;
    margin-right: 8px;
    animation: ${(props) => (props.$loading ? "spin 1s linear infinite" : "none")};

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

const FiltersBar = styled.form`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
    padding: 12px 15px 4px;
    flex-shrink: 0;
`;

const FilterGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const FilterLabel = styled.label`
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: #94a3b8;
`;

const FilterInput = styled.input`
    height: 34px;
    padding: 0 10px;
    border: 1.2px solid #d3d3d3;
    border-radius: 4px;
    font-size: 13px;
    min-width: 160px;
`;

const FilterSelect = styled.select`
    height: 34px;
    padding: 0 8px;
    border: 1.2px solid #d3d3d3;
    border-radius: 4px;
    font-size: 13px;
    background-color: #fff;
    min-width: 180px;
    cursor: pointer;
`;

const AplicarBtn = styled.button`
    height: 34px;
    padding: 0 18px;
    border: none;
    border-radius: 4px;
    background-color: #2563eb;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;

    &:hover {
        background-color: #1d4ed8;
    }
`;

const LimparBtn = styled.button`
    height: 34px;
    padding: 0 14px;
    border: 1.2px solid #d3d3d3;
    border-radius: 4px;
    background-color: transparent;
    font-size: 13px;
    color: #475569;
    cursor: pointer;

    &:hover {
        background-color: #f0f0f0;
    }
`;

const TotaisBar = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    padding: 8px 15px 12px;
    flex-shrink: 0;
`;

const TotalCard = styled.div`
    flex: 1;
    min-width: 150px;
    border: 1.2px solid #e2e8f0;
    border-left: 4px solid ${(props) => props.$accent || "#cbd5e1"};
    border-radius: 8px;
    padding: 8px 14px;
    background-color: #fff;
`;

const TotalLabel = styled.span`
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
`;

const TotalValue = styled.span`
    font-size: 22px;
    font-weight: 700;
    color: ${(props) => props.$color || "#1f2937"};
`;

const Body = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;
    margin-top: 5px;
    border-radius: 8px;
    border: 1.2px solid #d3d3d3;
    box-sizing: border-box;
`;

const LinhaTabela = styled.tr`
    cursor: pointer;

    &:hover {
        background-color: #f1f5f9;
    }
`;

const VinculoBadge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    background-color: ${(props) => (props.$vinculado ? "#dbeafe" : "#f1f5f9")};
    color: ${(props) => (props.$vinculado ? "#1e40af" : "#64748b")};
`;

const StatusPc = styled.span`
    display: inline-block;
    margin-left: 6px;
    padding: 2px 6px;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    background-color: ${(props) => (props.$finalizado ? "#dcfce7" : "#fef9c3")};
    color: ${(props) => (props.$finalizado ? "#166534" : "#854d0e")};
`;

const PreNotaBadge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    background-color: ${(props) => (props.$lancada ? "#dcfce7" : "#fef3c7")};
    color: ${(props) => (props.$lancada ? "#166534" : "#92400e")};
`;

const FILTROS_INICIAIS = {
    numNf: "",
    filial: "",
    codFornecedor: "",
    vinculo: "todos",
};

const NfsVinculo = () => {
    const api = useApi();
    const { isModalOpen, openModal, closeModal } = useModal();

    const [pagina, setPagina] = useState(1);
    const [loading, setLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);

    const [dados, setDados] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [periodo, setPeriodo] = useState({ inicio: "", fim: "" });
    const [totais, setTotais] = useState({ total: 0, com_vinculo: 0, sem_vinculo: 0 });

    const [filtros, setFiltros] = useState(FILTROS_INICIAIS);
    const [filtrosAplicados, setFiltrosAplicados] = useState(FILTROS_INICIAIS);

    const [detalhes, setDetalhes] = useState(null);
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);

    const fetchDados = async (page = pagina, f = filtrosAplicados) => {
        setLoading(true);

        try {
            const params = new URLSearchParams();
            params.append("page", page);
            params.append("limit", 50);

            if (f.numNf) params.append("num_nf", f.numNf);
            if (f.filial) params.append("filial", f.filial);
            if (f.codFornecedor) params.append("cod_fornecedor", f.codFornecedor);
            if (f.vinculo && f.vinculo !== "todos") params.append("vinculo", f.vinculo);

            const { data } = await api.get(
                `Painel/API/Controladoria/PedidosCompra/NfVinculo/index.php?${params.toString()}`
            );

            setDados(data.data || []);
            setTotalItems(data.quantidade || 0);
            setTotalPages(data.total_pages || 0);
            setTotais(data.totais || { total: 0, com_vinculo: 0, sem_vinculo: 0 });
            setPeriodo({
                inicio: data.periodo_inicio || "",
                fim: data.periodo_fim || "",
            });
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDados(pagina, filtrosAplicados);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagina, filtrosAplicados]);

    const refreshData = async () => {
        if (refreshing) return;
        setRefreshing(true);
        await fetchDados(pagina, filtrosAplicados);
        setRefreshing(false);
    };

    const atualizarFiltro = (campo, valor) => {
        setFiltros((atual) => ({ ...atual, [campo]: valor }));
    };

    const aplicarFiltros = (e) => {
        if (e) e.preventDefault();
        setFiltrosAplicados(filtros);
        setPagina(1);
    };

    const limparFiltros = () => {
        setFiltros(FILTROS_INICIAIS);
        setFiltrosAplicados(FILTROS_INICIAIS);
        setPagina(1);
    };

    const temFiltro =
        filtros.numNf !== "" ||
        filtros.filial !== "" ||
        filtros.codFornecedor !== "" ||
        filtros.vinculo !== "todos";

    const formatarPeriodo = () => {
        if (!periodo.inicio || !periodo.fim) return "";
        const fmt = (iso) => iso.split("-").reverse().join("/");
        return `Últimos 30 dias (${fmt(periodo.inicio)} a ${fmt(periodo.fim)})`;
    };

    const renderPedidosVinculados = (item) => {
        if (!item.TEM_VINCULO || !item.PEDIDOS_VINCULADOS?.length) {
            return <VinculoBadge $vinculado={false}>Sem vínculo</VinculoBadge>;
        }

        return item.PEDIDOS_VINCULADOS.map((p, idx) => (
            <span key={`${p.num_pedido}-${idx}`}>
                {idx > 0 && ", "}
                <VinculoBadge $vinculado={true}>PC {p.num_pedido}</VinculoBadge>
                {p.status_pc && (
                    <StatusPc $finalizado={p.status_pc === "FINALIZADO"}>{p.status_pc}</StatusPc>
                )}
            </span>
        ));
    };

    const abrirDetalhesNf = async (item) => {
        setDetalhes(null);
        setLoadingDetalhes(true);
        openModal("controladoria-selecionar-pc");

        try {
            const params = new URLSearchParams();
            params.append("filial", item.FILIAL);
            params.append("num_nf", item.NUM_NF);
            params.append("cod_fornecedor", item.FORNECEDOR_COD || "");
            if (item.FORNECEDOR_LOJA) params.append("loja_fornecedor", item.FORNECEDOR_LOJA);

            const { data } = await api.get(
                `Painel/API/Controladoria/PedidosCompra/NfVinculo/Detalhes/index.php?${params.toString()}`
            );

            if (data?.success) {
                setDetalhes(data);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoadingDetalhes(false);
        }
    };

    return (
        <Container>
            <Header>
                <Title>
                    Consulta de NFs
                    <Subtitle>{formatarPeriodo()}</Subtitle>
                </Title>
                <ActionsWrapper>
                    <button type="button" onClick={refreshData}>
                        <RefreshIcon $loading={refreshing} />
                        Atualizar
                    </button>
                </ActionsWrapper>
            </Header>

            <FiltersBar onSubmit={aplicarFiltros}>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-nf">Número da NF</FilterLabel>
                    <FilterInput
                        id="filtro-nf"
                        type="text"
                        placeholder="Ex: 000063803"
                        value={filtros.numNf}
                        onChange={(e) => atualizarFiltro("numNf", e.target.value)}
                    />
                </FilterGroup>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-filial">Filial</FilterLabel>
                    <FilterInput
                        id="filtro-filial"
                        type="text"
                        placeholder="Ex: 01010002"
                        value={filtros.filial}
                        onChange={(e) => atualizarFiltro("filial", e.target.value)}
                    />
                </FilterGroup>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-fornecedor">Cód. Fornecedor</FilterLabel>
                    <FilterInput
                        id="filtro-fornecedor"
                        type="text"
                        placeholder="Ex: 000123"
                        value={filtros.codFornecedor}
                        onChange={(e) => atualizarFiltro("codFornecedor", e.target.value)}
                    />
                </FilterGroup>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-vinculo">Vínculo com PC</FilterLabel>
                    <FilterSelect
                        id="filtro-vinculo"
                        value={filtros.vinculo}
                        onChange={(e) => atualizarFiltro("vinculo", e.target.value)}
                    >
                        <option value="todos">Todas</option>
                        <option value="com_vinculo">Com vínculo</option>
                        <option value="sem_vinculo">Sem vínculo</option>
                    </FilterSelect>
                </FilterGroup>
                <FilterGroup>
                    <AplicarBtn type="submit">Aplicar filtros</AplicarBtn>
                </FilterGroup>
                {temFiltro && (
                    <FilterGroup>
                        <LimparBtn type="button" onClick={limparFiltros}>
                            Limpar filtros
                        </LimparBtn>
                    </FilterGroup>
                )}
            </FiltersBar>

            <TotaisBar>
                <TotalCard $accent="#94a3b8">
                    <TotalLabel>Total de NFs</TotalLabel>
                    <TotalValue>{totais.total}</TotalValue>
                </TotalCard>
                <TotalCard $accent="#3b82f6">
                    <TotalLabel>Com vínculo ao PC</TotalLabel>
                    <TotalValue $color="#1d4ed8">{totais.com_vinculo}</TotalValue>
                </TotalCard>
                <TotalCard $accent="#f59e0b">
                    <TotalLabel>Sem vínculo</TotalLabel>
                    <TotalValue $color="#b45309">{totais.sem_vinculo}</TotalValue>
                </TotalCard>
            </TotaisBar>

            <Body>
                <PaginatedTable
                    pagina={pagina}
                    setPagina={setPagina}
                    loading={loading}
                    colunas={8}
                    totalItems={totalItems}
                    totalPages={totalPages}
                    thead={
                        <tr>
                            <th>FILIAL</th>
                            <th>NOTA</th>
                            <th>DATA EMISSÃO</th>
                            <th>FORNECEDOR</th>
                            <th>CÓD. FORN.</th>
                            <th>VALOR BRUTO</th>
                            <th>VÍNCULO PC</th>
                            <th>PRÉ NOTA</th>
                        </tr>
                    }
                >
                    <tbody>
                        {dados.map((item) => (
                            <LinhaTabela
                                key={`${item.FILIAL}-${item.NUM_NF}-${item.DT_NF}`}
                                onClick={() => abrirDetalhesNf(item)}
                            >
                                <td>{item.FILIAL}</td>
                                <td>{item.NUM_NF}</td>
                                <td>{item.DT_NF || " - "}</td>
                                <td>{item.FORNECEDOR || " - "}</td>
                                <td>{item.FORNECEDOR_COD || " - "}</td>
                                <td>
                                    {item.VALOR_BRUTO != null
                                        ? `R$ ${formatCurrency(item.VALOR_BRUTO)}`
                                        : " - "}
                                </td>
                                <td>{renderPedidosVinculados(item)}</td>
                                <td>
                                    <PreNotaBadge $lancada={item.TEM_PRE_NOTA}>
                                        {item.TEM_PRE_NOTA ? "Lançada" : "Pendente"}
                                    </PreNotaBadge>
                                </td>
                            </LinhaTabela>
                        ))}
                    </tbody>
                </PaginatedTable>
            </Body>

            {isModalOpen("controladoria-selecionar-pc") && (
                <ModalSelecionarPc
                    fecharModal={closeModal}
                    detalhes={detalhes}
                    loading={loadingDetalhes}
                    onVinculado={() => fetchDados(pagina, filtrosAplicados)}
                />
            )}
        </Container>
    );
};

export default NfsVinculo;
